import { Link } from "react-router-dom";
import { IoBookmark } from "react-icons/io5";
import { IoNotificationsSharp } from "react-icons/io5";
import { BsThreeDotsVertical } from "react-icons/bs";

import styles from "./Header.module.css";
import profileImg from "./profile.png";

import useUserData from "../../../Context/user/useUserData";
import MetadataContext from "../../../Context/metadataContext";
import { useContext } from "react";

function Header() {
  const { user, loginWithGoogle, logout } = useUserData();
  const isGoogleUser = !!user?.avatar;

  const { metadata } = useContext(MetadataContext);

  return (
    <div className={styles.header}>
      <Link to="/">
        <h1 className={styles["header-logo"]}>
          {metadata.domainText} {metadata.showBetaTag && <sup>Beta</sup>}
        </h1>
        {/* <h1 className={styles["header-logo"]}>{metadata.domainText}</h1> */}
      </Link>

      {/* <div className={styles['header-links']}>
        <span className={styles['header-link']}>Home</span>
        <span className={styles['header-link']}>Company Reviews</span>
      </div> */}

      <div className={styles["header-user-controls"]}>
        <Link to="/bookmarks" className={styles.bookmarkIcon}>
          <IoBookmark />
        </Link>

        {/* <IoNotificationsSharp /> */}

        {/* <div className={styles.profile}>
          <div className={styles['profile-picture']}>
            <img src={profileImg} alt="Profile" />
          </div>
          <div className={styles['profile-more']}>
            <BsThreeDotsVertical />
          </div>
        </div> */}

        {isGoogleUser && (
          <button className={styles["profile-picture"]}>
            <div>
              <span>
                <img
                  src={user.avatar}
                  alt="Profile"
                  referrerPolicy="no-referrer"
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                  style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "50%",
                  }}
                />
              </span>
            </div>
          </button>
        )}
      </div>
    </div>
  );
}

export default Header;
